(function attachAgoFirstUnitQa(global, factory) {
  'use strict';

  var api = factory();
  global.AgoFirstUnitQaV1 = api;
  if (global.document) api.boot(global);
})(typeof window !== 'undefined' ? window : globalThis, function createAgoFirstUnitQa() {
  'use strict';

  var CONFIG_ELEMENT_ID = 'AgoFirstUnitQaV1Config';
  var TEMPLATE_ELEMENT_ID = 'AgoFirstUnitQaOfferTemplate';
  var CART_REFRESH_DELAY_MS = 450;

  function assert(condition, message) {
    if (!condition) throw new Error(message);
  }

  function normalizeId(value) {
    var source = String(value == null ? '' : value).trim();
    var match = source.match(/\/(\d+)$/);
    return match ? match[1] : source.replace(/^\D+/, '');
  }

  function normalizeTag(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function normalizeHandle(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function normalizeSku(value) {
    return String(value == null ? '' : value).trim().toUpperCase();
  }

  function cents(value) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.round(number) : 0;
  }

  function positiveInteger(value, fallback) {
    var number = Number.parseInt(String(value), 10);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function normalizeRule(source) {
    if (!source || typeof source !== 'object') return null;
    var normalSellingCents = cents(source.normalSellingCents);
    var hookPriceCents = cents(source.hookPriceCents);
    var fixedAmountOffCents = cents(source.fixedAmountOffCents || normalSellingCents - hookPriceCents);
    var rule = {
      productId: normalizeId(source.productId),
      variantId: normalizeId(source.variantId),
      sku: normalizeSku(source.sku),
      handle: normalizeHandle(source.handle),
      displayName: String(source.displayName || 'Daily Essential').trim(),
      normalSellingCents: normalSellingCents,
      hookPriceCents: hookPriceCents,
      fixedAmountOffCents: fixedAmountOffCents,
      discountedQuantity: positiveInteger(source.discountedQuantity, 1),
      automaticDiscountTitle: String(source.automaticDiscountTitle || '').trim(),
      status: String(source.status || 'ACTIVE').trim().toUpperCase(),
    };
    if (!rule.productId || !rule.variantId || !rule.handle) return null;
    if (rule.status !== 'ACTIVE' || rule.discountedQuantity !== 1) return null;
    if (rule.normalSellingCents <= 0 || rule.hookPriceCents < 0 || rule.hookPriceCents >= rule.normalSellingCents) return null;
    if (rule.fixedAmountOffCents !== rule.normalSellingCents - rule.hookPriceCents) return null;
    return rule;
  }

  function rulesFromConfig(config) {
    var projection = config && config.projection;
    var sources = projection
      && String(projection.status || 'ACTIVE').toUpperCase() === 'ACTIVE'
      && Array.isArray(projection.rules)
      ? projection.rules.slice()
      : [];
    if (config && config.fixture && config.fixture.rule) sources.push(config.fixture.rule);
    var seen = {};
    return sources.map(normalizeRule).filter(function keep(rule) {
      if (!rule || seen[rule.variantId]) return false;
      seen[rule.variantId] = true;
      return true;
    });
  }

  function validateConfig(config) {
    assert(config && typeof config === 'object', 'Daily Essentials config is missing.');
    assert(config.schemaVersion === 2, 'Unsupported Daily Essentials schema.');
    assert(config.environment === 'THEME_FEATURE' && config.enabled === true, 'Daily Essentials feature is disabled.');

    if (config.fixture) {
    var fixture = config.fixture;
    assert(String(fixture.status || '').toUpperCase() === 'UNLISTED', 'Fixture must remain UNLISTED.');
    assert(normalizeRule(fixture.rule), 'Fixture rule is invalid.');
    assert(normalizeId(fixture.productId) === normalizeId(fixture.rule.productId), 'Fixture product does not match its rule.');
    assert(normalizeId(fixture.variantId) === normalizeId(fixture.rule.variantId), 'Fixture variant does not match its rule.');
    assert((fixture.forbiddenTags || []).map(normalizeTag).indexOf('new30') !== -1, 'new30 must remain explicitly forbidden.');
    }
    assert(rulesFromConfig(config).length > 0, 'No active Daily Essential rules are available.');
    return config;
  }

  function parseConfig(documentRef) {
    var element = documentRef.getElementById(CONFIG_ELEMENT_ID);
    assert(element, 'Daily Essentials config element is missing.');
    return validateConfig(JSON.parse(element.textContent || '{}'));
  }

  function identityMatchesRule(identity, rule) {
    if (!identity || !rule) return false;
    var variantId = normalizeId(identity.variantId || identity.variant_id || identity.id);
    var productId = normalizeId(identity.productId || identity.product_id);
    var sku = normalizeSku(identity.sku);
    var handle = normalizeHandle(identity.handle);
    if (variantId && variantId === rule.variantId) return true;
    if (productId && productId === rule.productId) return true;
    if (sku && sku === rule.sku) return true;
    return Boolean(handle && handle === rule.handle);
  }

  function findRule(identity, config) {
    return rulesFromConfig(config).find(function match(rule) {
      return identityMatchesRule(identity, rule);
    }) || null;
  }

  function isFixtureRule(rule, config) {
    return Boolean(rule && config && config.fixture
      && rule.variantId === normalizeId(config.fixture.variantId));
  }

  function productPageRule(config) {
    var context = config.pageContext || {};
    var rule = findRule({
      productId: context.productId,
      variantId: context.selectedVariantId,
      sku: context.selectedVariantSku,
      handle: context.handle,
    }, config);
    if (!rule || cents(context.selectedVariantPriceCents) !== rule.normalSellingCents) return null;
    if (!isFixtureRule(rule, config)) return rule;

    var tags = (context.tags || []).map(normalizeTag);
    if (tags.indexOf(normalizeTag(config.fixture.requiredTag)) === -1) return null;
    if ((config.fixture.requiredExclusionTags || []).some(function missing(tag) {
      return tags.indexOf(normalizeTag(tag)) === -1;
    })) return null;
    if ((config.fixture.forbiddenTags || []).some(function forbidden(tag) {
      return tags.indexOf(normalizeTag(tag)) !== -1;
    })) return null;
    return rule;
  }

  function productPageIsEligible(config) {
    return Boolean(productPageRule(config));
  }

  function expectedTotalCents(quantity, rule) {
    var safeQuantity = positiveInteger(quantity, 1);
    return rule.hookPriceCents + Math.max(0, safeQuantity - 1) * rule.normalSellingCents;
  }

  function formatMoney(valueCents, currencyCode, locale) {
    var value = Number(valueCents) / 100;
    if (String(currencyCode || '').toUpperCase() === 'AUD') return 'A$' + value.toFixed(2);
    try {
      return new Intl.NumberFormat(locale || 'en-AU', {
        style: 'currency',
        currency: currencyCode || 'AUD',
      }).format(value);
    } catch (_error) {
      return '$' + value.toFixed(2);
    }
  }

  function formatCompactMoney(valueCents, currencyCode, locale) {
    var value = Number(valueCents) / 100;
    if (String(currencyCode || '').toUpperCase() === 'AUD') {
      return 'A$' + (Number.isInteger(value) ? String(value) : value.toFixed(2));
    }
    try {
      return new Intl.NumberFormat(locale || 'en-AU', {
        style: 'currency',
        currency: currencyCode || 'AUD',
        minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (_error) {
      return '$' + (Number.isInteger(value) ? String(value) : value.toFixed(2));
    }
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function copyText(config, key, fallback) {
    return String(config && config.copy && config.copy[key] || fallback || '');
  }

  function quantityBreakdown(quantity, rule, config) {
    var safeQuantity = positiveInteger(quantity, 1);
    var hook = formatMoney(rule.hookPriceCents, config.currencyCode, config.locale);
    var normal = formatMoney(rule.normalSellingCents, config.currencyCode, config.locale);
    if (safeQuantity === 1) return '1 × ' + hook;
    return '1 × ' + hook + ' + ' + (safeQuantity - 1) + ' × ' + normal;
  }

  function compactQuantityBreakdown(quantity, rule, config) {
    var safeQuantity = positiveInteger(quantity, 1);
    var hook = formatCompactMoney(rule.hookPriceCents, config.currencyCode, config.locale);
    var normal = formatCompactMoney(rule.normalSellingCents, config.currencyCode, config.locale);
    if (safeQuantity === 1) return '1 × ' + hook;
    return '1 × ' + hook + ' + ' + (safeQuantity - 1) + ' × ' + normal;
  }

  function ruleCopy(rule, config, compact) {
    var money = compact ? formatCompactMoney : formatMoney;
    return copyText(config, 'first', 'First') + ' '
      + money(rule.hookPriceCents, config.currencyCode, config.locale)
      + ' · ' + copyText(config, 'then', 'then') + ' '
      + money(rule.normalSellingCents, config.currencyCode, config.locale)
      + ' ' + copyText(config, 'each', 'each');
  }

  function updateOfferCard(card, quantity, rule, config) {
    if (!card || !rule) return;
    var safeQuantity = positiveInteger(quantity, 1);
    setText(card.querySelector('[data-ago-first-unit-target]'), formatMoney(rule.hookPriceCents, config.currencyCode, config.locale));
    setText(card.querySelector('[data-ago-first-unit-selling]'), formatMoney(rule.normalSellingCents, config.currencyCode, config.locale));
    setText(card.querySelector('[data-ago-first-unit-breakdown]'), quantityBreakdown(safeQuantity, rule, config));
    setText(card.querySelector('[data-ago-first-unit-total]'), '= ' + formatMoney(expectedTotalCents(safeQuantity, rule), config.currencyCode, config.locale));
  }

  function updateOfferObstructionState(documentRef, card) {
    if (!card || typeof documentRef.elementsFromPoint !== 'function') return false;
    var box = card.getBoundingClientRect();
    if (!box.width || !box.height) return false;
    var pointX = box.left + 22;
    var probeYOffsets = [58, 82, 104];
    var obstructed = probeYOffsets.some(function probe(offset) {
      return documentRef.elementsFromPoint(pointX, box.top + Math.min(offset, box.height - 8)).some(function isKlaviyo(element) {
        return !card.contains(element)
          && Boolean(element.closest && element.closest('[class*="kl-private-reset-css"]'));
      });
    });
    card.classList.toggle('ago-first-unit-pdp--left-obstructed', obstructed);
    return obstructed;
  }

  function productHandleFromHref(value) {
    var href = String(value || '').split('#')[0].split('?')[0].replace(/^https?:\/\/[^/]+/i, '');
    var parts = href.split('/').filter(Boolean);
    var productIndex = parts.lastIndexOf('products');
    return productIndex !== -1 ? normalizeHandle(parts[productIndex + 1]) : '';
  }

  function cardProductLink(card) {
    var links = card.querySelectorAll('.product-title a[href], a.product-title[href], a[href*="/products/"]');
    for (var index = 0; index < links.length; index += 1) {
      if (productHandleFromHref(links[index].getAttribute('href'))) return links[index];
    }
    return null;
  }

  function cardRule(card, config) {
    var link = cardProductLink(card);
    return link ? findRule({handle: productHandleFromHref(link.getAttribute('href'))}, config) : null;
  }

  function cardFixturePreviewRequested(documentRef) {
    return String(documentRef.location && documentRef.location.search || '').indexOf('ago_first_unit_card_qa=1') !== -1;
  }

  function cardIsVisible(card, documentRef, fully) {
    var box = card.getBoundingClientRect();
    var viewportWidth = documentRef.defaultView && documentRef.defaultView.innerWidth || documentRef.documentElement.clientWidth;
    return box.width > 0 && (fully ? box.left >= 0 && box.right <= viewportWidth : box.right > 0 && box.left < viewportWidth);
  }

  function mountCardFixturePreview(documentRef, config) {
    if (!config.fixture || !cardFixturePreviewRequested(documentRef)) return null;
    var cards = Array.from(documentRef.querySelectorAll('.pr_grid_item, .prs_slide_item'));
    var card = cards.find(function preferred(candidate) { return cardIsVisible(candidate, documentRef, true); })
      || cards.find(function visible(candidate) { return cardIsVisible(candidate, documentRef, false); })
      || cards[0];
    if (!card) return null;
    card.setAttribute('data-ago-first-unit-qa-fixture-card', '');
    card.style.setProperty('--ago-first-unit-fixture-image', 'url("' + config.fixture.imageUrl + '")');
    var fixtureHref = '/products/' + config.fixture.handle;
    card.querySelectorAll('a[href]').forEach(function retarget(link) { link.setAttribute('href', fixtureHref); });
    var title = card.querySelector('.product-title a, a.product-title');
    if (title) setText(title, config.fixture.title);
    var price = card.querySelector('.product-info .price, .title-wrap .price');
    if (price) setText(price, formatMoney(config.fixture.rule.normalSellingCents, config.currencyCode, config.locale));
    card.querySelectorAll('.pr_lazy_img, .nt_bg_lz').forEach(function background(image) {
      image.removeAttribute('data-bgset');
      image.style.backgroundImage = 'url("' + config.fixture.imageUrl + '")';
    });
    card.querySelectorAll('img').forEach(function image(source) {
      source.setAttribute('src', config.fixture.imageUrl);
      source.removeAttribute('srcset');
      source.removeAttribute('data-src');
      source.removeAttribute('data-srcset');
      source.setAttribute('alt', 'Preview Daily Essential product');
    });
    card.querySelectorAll('.hover_img').forEach(function hide(image) { image.style.display = 'none'; });
    return card;
  }

  function mountCollectionCardDailyBadge(documentRef, card, rule, config) {
    var imageSlot = card.querySelector('.product-image, .prs_slide_wrap');
    if (!imageSlot) return;
    imageSlot.classList.add('ago-first-unit-card-image');
    var badge = imageSlot.querySelector('[data-ago-first-unit-card-daily]');
    if (!badge) {
      badge = documentRef.createElement('span');
      badge.className = 'ago-first-unit-daily-badge ago-first-unit-card-daily';
      badge.setAttribute('data-ago-first-unit-card-daily', '');
      badge.innerHTML = '<span data-ago-card-daily></span><span class="ago-first-unit-card-daily__price" data-ago-card-target></span>';
      imageSlot.appendChild(badge);
    }
    badge.setAttribute('aria-label', ruleCopy(rule, config, false));
    setText(badge.querySelector('[data-ago-card-daily]'), copyText(config, 'dailyEssential', 'Daily Essential'));
    setText(
      badge.querySelector('[data-ago-card-target]'),
      copyText(config, 'first', 'First') + ' ' + formatCompactMoney(rule.hookPriceCents, config.currencyCode, config.locale)
        + ' · ' + copyText(config, 'then', 'then') + ' ' + formatCompactMoney(rule.normalSellingCents, config.currencyCode, config.locale)
    );
  }

  function mountCollectionCardOffers(documentRef, config, allowFixturePreview) {
    if (allowFixturePreview) mountCardFixturePreview(documentRef, config);
    documentRef.querySelectorAll('.pr_grid_item, .prs_slide_item').forEach(function mount(card) {
      var rule = config.fixture && card.hasAttribute('data-ago-first-unit-qa-fixture-card')
        ? normalizeRule(config.fixture.rule)
        : cardRule(card, config);
      if (!rule) return;
      card.classList.add('ago-first-unit-list-card');
      mountCollectionCardDailyBadge(documentRef, card, rule, config);
      card.querySelectorAll('[data-ago-first-unit-card-offer]').forEach(function removeLegacy(offer) { offer.remove(); });
    });
  }

  function primaryProductQuantityInput(documentRef) {
    return documentRef.querySelector('#cart-form_ppr .qty_pr_js, #cart-form_ppr input[name="quantity"], .product-infors .qty_pr_js');
  }

  function clearLegacyHardMax(documentRef, rules) {
    documentRef.documentElement.classList.remove('ago-policy-hard-max-product');
    documentRef.body.classList.remove('ago-policy-hard-max-product');
    documentRef.querySelectorAll('.ago-purchase-policy-note, .ago-purchase-policy-toast').forEach(function removeLegacy(element) { element.remove(); });
    rules.forEach(function unlock(rule) {
      documentRef.querySelectorAll('[data-ago-policy-product-id="' + rule.productId + '"], .cart_item_' + rule.variantId + ' input[type="number"], #cart-form_ppr input[name="quantity"]').forEach(function unlockQuantity(input) {
        if (input.getAttribute('max') === '1') input.removeAttribute('max');
        input.removeAttribute('aria-valuemax');
        Array.from(input.attributes).forEach(function removePolicyAttribute(attribute) {
          if (attribute.name.indexOf('data-ago-policy') === 0) input.removeAttribute(attribute.name);
        });
      });
    });
  }

  function mountProductOffer(documentRef, config) {
    var rule = productPageRule(config);
    if (!rule) return null;
    documentRef.body.classList.add('ago-first-unit-product');
    clearLegacyHardMax(documentRef, [rule]);
    var existing = documentRef.querySelector('[data-ago-first-unit-offer]');
    if (!existing) {
      var template = documentRef.getElementById(TEMPLATE_ELEMENT_ID);
      assert(template && template.content, 'Daily Essentials offer template is missing.');
      var fragment = template.content.cloneNode(true);
      existing = fragment.querySelector('[data-ago-first-unit-offer]');
      var anchor = documentRef.querySelector('.price-review, #price_ppr, .product-infors .price_range');
      if (!anchor) return null;
      if (anchor.id === 'price_ppr') anchor = anchor.parentElement || anchor;
      anchor.insertAdjacentElement('afterend', existing);
    }
    existing.setAttribute('data-ago-first-unit-rule-variant', rule.variantId);
    var quantityInput = primaryProductQuantityInput(documentRef);
    updateOfferCard(existing, quantityInput ? quantityInput.value : 1, rule, config);
    updateOfferObstructionState(documentRef, existing);
    return existing;
  }

  function cartItems(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : [];
  }

  function findRuleForCartItem(item, config) {
    return findRule({
      productId: item && item.product_id,
      variantId: item && (item.variant_id || item.id),
      sku: item && item.sku,
      handle: item && item.handle,
    }, config);
  }

  function discountAllocationAmountCents(item, title) {
    return (item && Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [])
      .filter(function matching(allocation) {
        return String(allocation && allocation.discount_application && allocation.discount_application.title || '') === title;
      })
      .reduce(function sum(total, allocation) { return total + Number(allocation.amount || 0); }, 0);
  }

  function cssEscape(value) {
    if (typeof CSS !== 'undefined' && CSS.escape) return CSS.escape(String(value));
    return String(value).replace(/([ #;?%&,.+*~\':"!^$[\]()=>|/@])/g, '\\$1');
  }

  function cartLineContainers(documentRef, item) {
    var selectors = ['.cart_item_' + normalizeId(item.variant_id || item.id)];
    if (item.key) selectors.push('[data-id="' + cssEscape(item.key) + '"]');
    var containers = [];
    documentRef.querySelectorAll(selectors.join(',')).forEach(function collect(element) {
      var container = element.matches('.mini_cart_item, .cart_item') ? element : element.closest('.mini_cart_item, .cart_item, tr, [data-cart-item]');
      if (container && containers.indexOf(container) === -1) containers.push(container);
    });
    return containers;
  }

  function lineFinalCents(item, rule) {
    var actual = Number(item && item.final_line_price);
    return Number.isFinite(actual) ? Math.round(actual) : expectedTotalCents(item && item.quantity, rule);
  }

  function lineOriginalCents(item, rule) {
    var actual = Number(item && item.original_line_price);
    return Number.isFinite(actual) ? Math.round(actual) : positiveInteger(item && item.quantity, 1) * rule.normalSellingCents;
  }

  function cartLiveSummary(quantity, item, rule, config) {
    var safeQuantity = positiveInteger(quantity, 1);
    var finalCents = lineFinalCents(item, rule);
    var expectedCents = expectedTotalCents(safeQuantity, rule);
    var quantityCopy = safeQuantity === 1 ? 'item' : 'items';

    // Shopify's returned line total is the customer-facing source of truth.
    // A formula is shown only while it reconciles to that amount, so another
    // compatible same-line promotion can never make the Cart copy misleading.
    if (finalCents !== expectedCents) {
      return safeQuantity + ' ' + quantityCopy + ' · '
        + formatCompactMoney(finalCents, config.currencyCode, config.locale);
    }
    if (safeQuantity === 1) {
      return '1 item · ' + formatCompactMoney(finalCents, config.currencyCode, config.locale);
    }
    return safeQuantity + ' items · ' + compactQuantityBreakdown(safeQuantity, rule, config)
      + ' = ' + formatCompactMoney(finalCents, config.currencyCode, config.locale);
  }

  function updateNativeCartAmounts(documentRef, container, item, rule, config) {
    var price = container.querySelector('.cart_price');
    if (price) {
      price.classList.add('ago-first-unit-native-price');
      price.setAttribute('aria-hidden', 'true');
    }
    var dailyLabel = normalizeTag(copyText(config, 'dailyEssential', 'Daily Essential'));
    container.querySelectorAll('.cart_discount_price, .order-discount__item').forEach(function hideDailyAllocation(allocation) {
      var allocationText = normalizeTag(allocation.textContent || '');
      var hasExactTitle = rule.automaticDiscountTitle && allocationText.indexOf(normalizeTag(rule.automaticDiscountTitle)) !== -1;
      var hasDailyLabel = dailyLabel && allocationText.indexOf(dailyLabel) !== -1;
      var childAllocations = allocation.querySelectorAll('.order-discount__item');
      var hasNonDailyChild = Array.from(childAllocations).some(function isNonDaily(child) {
        var childText = normalizeTag(child.textContent || '');
        return childText.indexOf(dailyLabel) === -1
          && (!rule.automaticDiscountTitle || childText.indexOf(normalizeTag(rule.automaticDiscountTitle)) === -1);
      });
      if ((hasExactTitle || hasDailyLabel) && !hasNonDailyChild) {
        allocation.classList.add('ago-first-unit-daily-discount');
      }
    });
    var total = container.querySelector('.js_tt_price_it');
    if (total) {
      var finalCents = lineFinalCents(item, rule);
      var originalCents = lineOriginalCents(item, rule);
      setText(total, formatMoney(finalCents, config.currencyCode, config.locale));
      var was = total.parentElement && total.parentElement.querySelector('[data-ago-first-unit-was]');
      if (finalCents < originalCents && !was) {
        was = documentRef.createElement('small');
        was.className = 'ago-first-unit-cart-was';
        was.setAttribute('data-ago-first-unit-was', '');
        total.insertAdjacentElement('afterend', was);
      }
      if (was) setText(was, copyText(config, 'was', 'Was') + ' ' + formatMoney(originalCents, config.currencyCode, config.locale));
    }
  }

  function mountCartLineSummary(documentRef, item, rule, config) {
    cartLineContainers(documentRef, item).forEach(function mount(container) {
      container.classList.add('ago-first-unit-cart-line');
      updateNativeCartAmounts(documentRef, container, item, rule, config);
      var summary = container.querySelector('[data-ago-first-unit-cart-summary]');
      if (!summary) {
        summary = documentRef.createElement('div');
        summary.className = 'ago-first-unit-cart-summary';
        summary.setAttribute('data-ago-first-unit-cart-summary', '');
        summary.setAttribute('role', 'status');
        summary.setAttribute('aria-live', 'polite');
        summary.innerHTML = '<div class="ago-first-unit-cart-summary__labels"><span class="ago-first-unit-daily-badge" data-ago-cart-daily></span></div>'
          + '<div class="ago-first-unit-cart-summary__live" data-ago-cart-live></div>';
        var anchor = container.querySelector('.mini_cart_meta, .cart_meta_price, .cart_price, .mini_cart_title');
        if (anchor) anchor.insertAdjacentElement('afterend', summary);
        else container.appendChild(summary);
      }
      var quantity = positiveInteger(item.quantity, 1);
      setText(summary.querySelector('[data-ago-cart-daily]'), copyText(config, 'dailyEssential', 'Daily Essential'));
      setText(summary.querySelector('[data-ago-cart-live]'), cartLiveSummary(quantity, item, rule, config));
    });
  }

  function removeInternalCheckoutNotes(documentRef) {
    documentRef.querySelectorAll('[data-ago-first-unit-checkout-note]').forEach(function remove(note) { note.remove(); });
  }

  function normalizeRoot(root) {
    var value = String(root || '/');
    if (value.charAt(0) !== '/') value = '/' + value;
    if (value.charAt(value.length - 1) !== '/') value += '/';
    return value.replace(/\/{2,}/g, '/');
  }

  function fetchCart(host) {
    var root = normalizeRoot(host.Shopify && host.Shopify.routes && host.Shopify.routes.root);
    return host.fetch(root + 'cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(function parse(response) {
        if (!response.ok) throw new Error('Unable to read Shopify cart.');
        return response.json();
      });
  }

  function renderCart(host, config) {
    return fetchCart(host).then(function render(cart) {
      clearLegacyHardMax(host.document, rulesFromConfig(config));
      cartItems(cart).forEach(function mount(item) {
        var rule = findRuleForCartItem(item, config);
        if (rule) mountCartLineSummary(host.document, item, rule, config);
      });
      removeInternalCheckoutNotes(host.document);
      return cart;
    });
  }

  function boot(host) {
    var config;
    try {
      config = parseConfig(host.document);
    } catch (error) {
      host.console.error('[AGO Daily Essentials]', error);
      return;
    }
    var cartTimer = null;
    var mutationScheduled = false;

    function refreshProduct() {
      var card = mountProductOffer(host.document, config);
      var rule = productPageRule(config);
      var quantityInput = primaryProductQuantityInput(host.document);
      if (card && rule) updateOfferCard(card, quantityInput ? quantityInput.value : 1, rule, config);
    }

    function refreshProductCards(allowFixturePreview) {
      mountCollectionCardOffers(host.document, config, allowFixturePreview === true);
    }

    function scheduleCart(delay) {
      if (cartTimer) host.clearTimeout(cartTimer);
      cartTimer = host.setTimeout(function refreshCart() {
        renderCart(host, config).catch(function log(error) { host.console.warn('[AGO Daily Essentials]', error.message || error); });
      }, delay == null ? CART_REFRESH_DELAY_MS : delay);
    }

    function refreshAll() {
      refreshProduct();
      refreshProductCards(false);
      scheduleCart(0);
    }

    host.document.addEventListener('input', function handleInput(event) {
      if (event.target && event.target.matches('.qty_pr_js, #cart-form_ppr input[name="quantity"]')) refreshProduct();
    }, true);
    host.document.addEventListener('change', function handleChange(event) {
      if (event.target && event.target.matches('input[type="number"], select[name="id"]')) {
        refreshProduct();
        scheduleCart();
      }
    }, true);
    host.document.addEventListener('click', function handleClick(event) {
      if (event.target && event.target.closest('.plus, .minus, .js_addtc, [name="add"], .cart_ac_remove')) {
        host.setTimeout(refreshProduct, 30);
        scheduleCart(700);
      }
    }, true);
    ['cart:refresh', 'cart:updated', 'ajaxProduct:added'].forEach(function listen(eventName) {
      host.document.addEventListener(eventName, function refreshAfterThemeEvent() { scheduleCart(100); });
    });
    var observer = new host.MutationObserver(function observe() {
      if (mutationScheduled) return;
      mutationScheduled = true;
      host.setTimeout(function afterMutation() {
        mutationScheduled = false;
        refreshProduct();
        refreshProductCards(false);
        if (host.document.querySelector('.mini_cart_item, [data-cart-item], .cart_item')) scheduleCart(100);
      }, 80);
    });
    observer.observe(host.document.documentElement, {childList: true, subtree: true});
    host.setTimeout(function settledFixture() { refreshProductCards(true); }, 3200);
    host.addEventListener('pageshow', refreshAll);
    refreshAll();
  }

  return {
    boot: boot,
    compactQuantityBreakdown: compactQuantityBreakdown,
    cartLiveSummary: cartLiveSummary,
    discountAllocationAmountCents: discountAllocationAmountCents,
    expectedTotalCents: expectedTotalCents,
    findRule: findRule,
    findRuleForCartItem: findRuleForCartItem,
    formatCompactMoney: formatCompactMoney,
    formatMoney: formatMoney,
    identityMatchesRule: identityMatchesRule,
    lineFinalCents: lineFinalCents,
    normalizeId: normalizeId,
    normalizeRule: normalizeRule,
    productHandleFromHref: productHandleFromHref,
    productPageIsEligible: productPageIsEligible,
    productPageRule: productPageRule,
    quantityBreakdown: quantityBreakdown,
    rulesFromConfig: rulesFromConfig,
    updateOfferObstructionState: updateOfferObstructionState,
    validateConfig: validateConfig,
  };
});
